import * as React from "react";
const SvgSmallArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M12 10.571L8 6 4 10.571z", transform: "rotate(-180 8 8.286)" }));
export default SvgSmallArrowDown;
